import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ChatRequestModel } from "src/app/shared/models/chat-request";

@Injectable({
  providedIn: "root",
})
export class ChatbotService {
  constructor(private http: HttpClient) {}
  apiRoot = `${environment.apiUrl}Chatbot`;
  public sendMessage(
    chatRequest: ChatRequestModel
  ): Observable<ChatRequestModel> {
    return this.http.post<ChatRequestModel>(
      `${this.apiRoot}/sendMessage`,
      chatRequest,
      {
        responseType: "json",
      }
    );
  }
}
